import { render } from "./ReminderBreakdownChart.vue?vue&type=template&id=a30f7fe4&scoped=true"
import script from "./ReminderBreakdownChart.vue?vue&type=script&lang=js"
export * from "./ReminderBreakdownChart.vue?vue&type=script&lang=js"

import "./ReminderBreakdownChart.vue?vue&type=style&index=0&id=a30f7fe4&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a30f7fe4"]])

export default __exports__